module.exports = __webpack_public_path__ + "img/96.2e6c39fa.jpg";